import selectShowPreviewTextOption from '../actions/selectShowPreviewTextOption';
import MessagePreviewOptionState from '../store/schema/MessagePreviewOptionState';
import store from '../store/store';
import { getFallbackValueIfNull } from 'owa-options-core';
import { ChoiceGroup, IChoiceGroupOption } from 'office-ui-fabric-react/lib/ChoiceGroup';
// import ReadReceiptResponse from 'owa-service/lib/contract/ReadReceiptResponse';
import UserOptionsType from 'owa-service/lib/contract/UserOptionsType';
import { getUserConfiguration } from 'owa-session-store';
import strings from 'owa-strings/owa-options-strings';
import * as React from 'react';
import { reactive } from 'satcheljs/lib/legacy/react';

export interface MessagePreviewFullProps {
    optionStore?: MessagePreviewOptionState;
    userOptions?: UserOptionsType;
}

@reactive({
    optionStore: () => store,
    userOptions: () => getUserConfiguration().UserOptions,
})
export default class MessagePreviewFull extends React.Component<MessagePreviewFullProps, {}> {
    render() {
        let { optionStore, userOptions } = this.props;

        let showPreviewText = getFallbackValueIfNull(
            optionStore.showPreviewTextInListView,
            userOptions.ShowPreviewTextInListView
        );

        return (
            <ChoiceGroup
                selectedKey={`${showPreviewText}`}
                options={[
                    {
                        key: 'true',
                        text: strings.options_messageList_previewShow,
                    },
                    {
                        key: 'false',
                        text: strings.options_messageList_previewHide,
                    },
                ]}
                onChange={this.onShowPreviewTextChange}
                label={strings.options_messageList_previewLabel}
            />
        );
    }

    private onShowPreviewTextChange = (
        ev?: React.FormEvent<HTMLElement | HTMLInputElement>,
        option?: IChoiceGroupOption
    ) => {
        selectShowPreviewTextOption(option.key === 'true');
    };
}
